import axios from 'axios';
import React, { useMemo } from 'react';
import { isMobile } from 'react-device-detect';
import { AppContext } from '../App';
import './index.scss';
import { InternalOptions } from '../types';
import Hero from '../assets/hero-internationalization-us-en.gif';
import { ReturnToHomeButton } from '../Header';

interface PISProps {}

const PISV2: React.FC<PISProps> = () => {
  const {
    dispatch,
    amount,
    countryCode,
    currency,
    page,
    successfulExtraction,
    scheme,
    forceDesktop,
    isDonation,
    recipientId,
    language,
    customizationName,
  } = React.useContext(AppContext);
  const [error, setError] = React.useState('');
  const internalOptions: InternalOptions = useMemo(() => ({}), []);
  if (forceDesktop) {
    internalOptions.forceDesktop = true;
  }

  React.useEffect(() => {
    if (!amount) {
      setError('A payment amount has not been provided');
      return;
    }
    axios
      .post(
        `${process.env.REACT_APP_SERVER_URL}/token/payment`,
        {
          amount: amount.toFixed(2),
          isMobile,
          countryCode,
          currency,
          scheme,
          isDonation,
          recipientId,
          language,
          customizationName,
        },
        { withCredentials: true },
      )
      .then((response) => {
        if (response.data.link_token) {
          // @ts-ignore
          let plaidLink = Plaid.create(
            {
              token: response.data.link_token,
              // @ts-ignore
              onSuccess: async (token, metadata) => {
                dispatch({
                  type: 'SET_SUCCESSFUL_EXTRACTION',
                  payload: {
                    successfulExtraction: true,
                  },
                });
              },
              // @ts-ignore
              onExit: async (err, metadata) => {
                // Return to the Landing page for any error or exit event from Link.
                dispatch({
                  type: 'SET_PAGE',
                  payload: {
                    page: 'landingV2',
                  },
                });
                plaidLink = undefined;
              },
              // @ts-ignore
              onEvent: (eventName, metadata) => {},
            },
            internalOptions,
          );
          plaidLink.open();
          // Change Link's zIndex so the demo banner can be seen
          const iframes = Array.from(document.getElementsByTagName('iframe'));
          iframes.forEach((iframe) => (iframe.style.zIndex = '2147483646'));
        } else {
          setError(response.data.error);
        }
      })
      .catch((error) => {
        setError(error);
      });
  }, [
    dispatch,
    amount,
    countryCode,
    currency,
    page,
    scheme,
    isDonation,
    recipientId,
    language,
    customizationName,
    internalOptions,
  ]);

  return successfulExtraction ? <PISV2Inner /> : <></>;
};

const PISV2Inner: React.FC = () => {
  return (
    <div style={{ textAlign: 'center' }}>
      <div className="PISV2__title">You are all done!</div>
      <div style={{ padding: '40px 0px' }}>
        Want to try another Product? Let's go.
      </div>
      <ReturnToHomeButton />
      <img
        src={Hero}
        width="100%"
        alt="decorative animation depicting a trans-atlantic network of data connections"
      />
    </div>
  );
};

export default PISV2;
